<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div class="row">
                    <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
                    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
                        <div class="modal-container" @click.stop>

                            <div class="modal-header row">
                                <div class="col-10">
                                    <h2>Edit Dealer Radius</h2>
                                </div>
                                <div class="col-2" style="justify-content: flex-end;">
                                    <button type="button" class="close" @click="$emit('closeModal')">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>

                            <div class="modal-body">

                                <div class="row">
                                    <div class="col pr-5 pl-5">
                                      <label>Dealer</label>
                                      <MultiSelect
                                        v-model="data.kd_dealer"
                                        :options="options.dealer.map(x => x.code)"
                                        :custom-label="opt => options.dealer.find(x => x.code == opt).name"
                                        placeholder="Choose Dealer"
                                      ></MultiSelect>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6 pr-5 pl-5">
                                        <p>Ring 1 (in KM)</p>
                                        <div class="row">
                                            <input type="number" class="col-md-5 form-control" disabled value="0">
                                            <span class="col-md-2 text-center pb-0 pt-2"> - </span>
                                            <input type="number" class="col-md-5 form-control" v-model="form.ring_1">
                                        </div>
                                    </div>

                                    <div class="col-md-6 pr-5 pl-5">
                                        <p>Ring 2 (in KM)</p>
                                        <div class="row">
                                            <input type="number" class="col-md-5 form-control" disabled :value="form.ring_1">
                                            <span class="col-md-2 text-center pb-0 pt-2"> - </span>
                                            <input type="number" class="col-md-5 form-control" v-model="form.ring_2">
                                        </div>
                                    </div>

                                    <div class="col-md-6 pr-5 pl-5">
                                        <p>Ring 3 (in KM)</p>
                                        <div class="row">
                                            <input type="number" class="col-md-5 form-control" disabled :value="form.ring_2">
                                            <span class="col-md-2 text-center pb-0 pt-2"> - </span>
                                            <input type="number" class="col-md-5 form-control" v-model="form.ring_3">
                                        </div>
                                    </div>

                                    <div class="col-md-6 pr-5 pl-5">
                                        <p>Ring 4 (in KM)</p>
                                        <div class="row">
                                            <span class="col-md-2 offset-md-5 text-center pb-0 pt-2"> > </span>
                                            <input type="number" class="col-md-5 form-control" disabled :value="form.ring_3">
                                        </div>
                                    </div>
                                </div>

                                <div class="row mt-4">
                                    <div class="col text-center">
                                        <button class="btn btn-outline-danger" style="width: 90px;" @click="$emit('closeModal')">Cancel</button>
                                        <button class="btn btn-primary ml-3" style="width: 90px;" @click="submit">Edit</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import MultiSelect from 'vue-multiselect';
    
    export default {
        data() {
            return {
                options: {
                    dealer : this.$store.getters.getDealer(),
                },
                form : {
                    ring_1 : 0,
                    ring_2 : 0,
                    ring_3 : 0
                }
            }
        },
        props: ['data'],
        components : {
            MultiSelect,
        },
        mounted() {
            this.form.ring_1 = this.data.ring_1;
            this.form.ring_2 = this.data.ring_2;
            this.form.ring_3 = this.data.ring_3;
        },
        watch: {
            'form.ring_1' () {
                if (parseInt(this.form.ring_1) < 0) this.form.ring_1 = 0;

                if (parseInt(this.form.ring_2) < parseInt(this.form.ring_1)) this.form.ring_2 = this.form.ring_1;
            },
            'form.ring_2' () {
                if (parseInt(this.form.ring_2) < 0) this.form.ring_2 = 0;

                if (parseInt(this.form.ring_2) < parseInt(this.form.ring_1)) this.form.ring_2 = this.form.ring_1;
                if (parseInt(this.form.ring_3) < parseInt(this.form.ring_2)) this.form.ring_3 = this.form.ring_2;
            },
            'form.ring_3' () {
                if (parseInt(this.form.ring_3) < 0) this.form.ring_3 = 0;

                if (parseInt(this.form.ring_3) < parseInt(this.form.ring_2)) this.form.ring_3 = this.form.ring_2;
            },
        },
        methods: {
            submit () {
                if (this.inputValid()) {
                    this.$http.put(`/api/setting/dealer-radius/${this.data.kd_dealer}`, this.form)
                    .then((resp)=>{
                        this.$emit('triggerAlert', false, ['Dealer radius has been successfully modified']);
                        this.$emit('refreshTable');
                        this.$emit('closeModal');
                    })
                    .catch((err)=>{
                        console.log(err);
                        this.$emit('triggerAlert', true, ['An error has occured! We apologize for the incovenience, please contact QTrust Admin immediately.'])
                    })
                }
            },
            inputValid () {
                let errors = []

                // if (this.form.kd_dealer == null || this.form.kd_dealer == "") errors.push("Dealer is required")

                if (this.form.ring_1 == 0) errors.push("Ring 1 must not be 0")
                if (this.form.ring_2 == 0) errors.push("Ring 2 must not be 0")
                if (this.form.ring_3 == 0) errors.push("Ring 3 must not be 0")

                if (this.form.ring_1 == this.form.ring_2) errors.push("Ring 1 must not be identical to Ring 2")
                if (this.form.ring_2 == this.form.ring_3) errors.push("Ring 2 must not be identical to Ring 3")

                if (errors.length == 0) return true;
                
                this.$emit('triggerAlert', true, errors);
            },
        }
    }
</script>

<style>

</style>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 1020;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
        overflow: auto;
        min-height: 40vh;
        max-height: 80vh;
        max-width: 80vw;
    }

    .modal-default-button {
        float: right;
    }

    /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /* MODAL STARTS */
    .modal-body {
        margin: 0
    }

    .modal-body .moduleLine {
        margin-bottom: 0vh;
    }

    .modal-body .moduleLine a {
        text-decoration: none;
    }

    .modal-body .moduleLine .moduleBox:hover {
        background-color: #E0E0E0;
        transition: background-color 0.7s ease;
        color: #212121;
        transition: color 0.7s ease;
    }

    .modal-body .moduleLine .moduleBox {
        border: 1px solid #BDBDBD;
        border-radius: 20px;
        padding: 20px 0;
        color: black;
        margin-bottom: 3vh;
    }

    .modal-body .moduleLine .moduleBox i {
        font-size: 5vh;
    }

    h3.modalHeadline {
        margin: 0 0 20px 0;
        font-weight: bold;
        text-align: center;
    }

    /* MODAL ENDS */

    code {
        background-color: transparent;
        color: black;
    }

    pre {
        outline: 1px solid #ccc;
        padding: 5px;
        margin: 5px;
    }

    .stringHighlight {
        color: green;
    }

    .numberHighlight {
        color: darkorange;
    }

    .booleanHighlight {
        color: blue;
    }

    .nullHighlight {
        color: magenta;
    }

    .keyHighlight {
        color: red;
    }
</style>